/*========================================================================
 * $Id: i18n.js 439120 2020-10-09 12:18:48Z aleksandar.batin $
 *
 * Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
 *
 * Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
 * Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
 * Urheber festgelegten Stelle in der Funktion des Computerprogramms
 * angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
 * Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
 * Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
 * =========================================================================*/


(function() {
  var currentLang = function (lang) {
    var langAvailable = function (lang) {
        var langs = ["bg", "bg-bg", "cs", "cs-cz", "de", "de-at", "de-ch", "de-de", "de-li",  "de-lu", "en", "en-gb", "en-us", "es", "es-es" , "fr", "fr-fr", "hr", "hr-hr", "hu", "hu-hu", "id", "id-id",
        "it", "it-it", "ja", "ja-jp", "nb", "nb-no", "nl", "nl-nl", "pl", "pl-pl", "pt", "pt-pt", "ro", "ro-ro", "ru", "ru-ru", "si", "si-si", "sk", "sk-sk", "sl", "sl-si", "sr", "sr-latn-cs",
        "tr", "tr-tr", "zh", "zh-hans-cn"];
        var i = langs.length - 1;
        while (i >= 0) {
          if (langs[i] === lang) return true;
          i--;
        }
    };

    var lang = lang || (typeof document !== "undefined" && document.documentElement.lang);

    if (lang) {
      lang = lang.toLowerCase();
      if (langAvailable(lang)) return lang;
      if (lang.length > 2) {
        lang = lang.substring(0, 2);
        if (langAvailable(lang)) return lang;
      }
    }

    return "en-us";
  };

  define([
    'translations/i18n-en',
    "backbone",
    "underscore",
    "mbmustache",
    "jquery"
  ], function(
    initialStrings,
    Backbone,
    _,
    Mustache,
    $
  ) {

    var i18n = function (name, context) {
      if (!i18n.strings[name]) {
        i18n.missing = i18n.missing || [];
        if (!_.contains(i18n.missing, name)) i18n.missing.push(name);
        return name;
      }

      var str = i18n.strings[name];
      if (!str) return name; // TODO: only for debugging?

      if (_.isArray(context)) {
        for (var i=context.length-1; i>=0; i--) {
          str = str.replace(new RegExp('\\{'+i+'\\}'), context[i]);
        }
        return str;
      } else {
        return Mustache.to_html(str, context);
      }
    };

    _.extend(i18n, Backbone.Events);

    i18n.translateIfPrefixed = function (str) {
      if (/^i18n\./.test(str)) {
        return i18n(str.substring(5));
      }
      return str;
    }

    i18n._setLocaleAndStrings = function(locale, strings) {
      this.strings = strings;
      this.locale = locale;
      i18n.trigger("change:locale", this);
    }

    i18n.additionalStrings = {};

    i18n.setLocale = function(locale, callback) {
      var lang = i18n.normalizeLocale(locale);
      Mindbreeze.require(["translations/i18n-" + lang], function(strings) {
        i18n._setLocaleAndStrings(locale, strings);
        i18n.loadExtension();
        i18n.patchI18nAttributes();
        if (callback) {
          callback(i18n);
        }
      });
    }

    i18n.currentLocale = function() { return  currentLang(); }
    i18n.currentLanguage = function () {
      var currentLanguage = i18n.currentLocale();
      return currentLanguage && currentLanguage.split("-") && currentLanguage.split("-")[0];
    }
    i18n.normalizeLocale = currentLang;

    i18n.loadExtension = function(extension) {
      if(extension) {
        _.extend(i18n.additionalStrings, extension);
      }
      _.forEach(i18n.additionalStrings, function (translations, key) {
        let currentKeys = Object.keys(translations);
        if (currentKeys.length === 0) {
          i18n.strings[key] = key;
        }

        for (var i = 0; i < currentKeys.length; i++) {
          if (new RegExp("^" + currentKeys[i]).test(i18n.locale)) {
            i18n.strings[key] = translations[currentKeys[i]];
            break;
          } else {
            if (currentKeys && currentKeys[0]) {
              var enKey = i18n.containsEnglishKey(currentKeys);
              i18n.strings[key] = translations[enKey || currentKeys[0]];
            }
          }
        }
      });
    };

    i18n.additionalMetadataTranslations = function (translationObject) {
      if (!translationObject) return;
      i18n.metadataTranslations = translationObject;
    };

    i18n.containsEnglishKey = function(currentKeys) {
      if (currentKeys.includes('en')) {
        return 'en';
      }

      for (var i = 0; i < currentKeys.length; i++) {
        if (new RegExp(/^en-/).test(currentKeys[i])) {
          return currentKeys[i];
        }
      }

      return '';
    };

    // will be compatible to: http://i18next.com/pages/doc_jquery.html
    i18n.patchI18nAttributes = function (elOrSelector) {
      elOrSelector = elOrSelector || "body";
      $(elOrSelector).find("[data-i18n]").each(function () {
        var i18nString = this.getAttribute("data-i18n"),
        parts = i18nString.split(";");
        _.each(parts, i18n.updateTranslation, this);
      });
    };

    i18n.updateTranslation = function (translationString) {
      if (!translationString) return;

      var match = translationString.match(/(^\[([^\]]+)\])?(.*)/), // [attributeName]key or just key
          attributeName = match && match[2],
          key = match && match[3];

      if(attributeName=='html') {
        $(this).html(i18n(key));
      } else if (attributeName) {
        this.setAttribute(attributeName, i18n(key));
      } else {
        $(this).text(i18n(key));
      }
    };

    var initalLang = ((typeof document !== "undefined" && document.documentElement.lang) || "en-US");
    i18n._setLocaleAndStrings(initalLang, initialStrings);

    return i18n
  });

})();
